import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";
import { customFieldValues } from "../custom_fields";

export const productServiceTypes = v.union(
  v.literal("product"),
  v.literal("service"),
);

export const productServiceStatus = v.union(
  v.literal("active"),
  v.literal("inactive"),
  v.literal("discontinued"),
);

export const validatorProductService = v.object({
  internalControl: internalControl,
  /** Valores de campos personalizados (Colecciones), por key de definición. */
  customFields: v.optional(customFieldValues),

  name: v.string(),
  description: v.optional(v.string()),
  type: productServiceTypes,
  code: v.optional(v.string()), // SKU o código interno
  barcode: v.optional(v.string()),
  model: v.optional(v.string()),

  categories: v.optional(v.array(v.id("categories"))),
  brandId: v.optional(v.id("brands")),
  supplierId: v.id("suppliers"),
  category: v.optional(v.string()),
  unitPrice: v.number(),
  purchasePrice: v.number(),
  currency: v.optional(v.string()),
  unit: v.optional(v.string()), // unidad, pieza, kg, litro, etc.

  taxRate: v.optional(v.number()),
  taxAmount: v.optional(v.number()),
  isExempt: v.optional(v.boolean()), // f) ítem exento
  exemptRate: v.optional(v.number()), // f) tasa de exención
  exemptAmount: v.optional(v.number()), // f) monto exento
  discountRate: v.optional(v.number()), // g) porcentaje de descuento
  discountAmount: v.optional(v.number()), // g) monto de descuento

  status: v.optional(productServiceStatus),

  stockQuantity: v.optional(v.number()), // Deprecated: usar stockStatus table
  minStockLevel: v.optional(v.number()),
  maxStockLevel: v.optional(v.number()),
  // Promedio ponderado móvil. Se recalcula al recibir mercancía de una orden de compra.
  // `purchasePrice` es el precio de referencia; `averageCost` es el costo real.
  averageCost: v.optional(v.number()),

  weight: v.optional(v.number()),
  dimensions: v.optional(v.string()), // JSON: {length, width, height}

  hasExpirationControl: v.optional(v.boolean()),
  defaultExpirationDays: v.optional(v.number()), // Días hasta vencimiento por defecto

  imageId: v.optional(v.id("_storage")),
  imageIds: v.optional(v.array(v.id("_storage"))),

  notes: v.optional(v.string()),
  tags: v.optional(v.array(v.string())),
});

export const products = defineTable(validatorProductService)
  .index("by_type", ["type"])
  .index("by_status", ["status"])
  .index("by_code", ["code"])
  .index("by_company_and_code", ["internalControl.companyId", "code"])
  .index("by_company_and_barcode", ["internalControl.companyId", "barcode"])
  .index("by_company_and_type", ["internalControl.companyId", "type"])
  .index("by_company_and_brand", ["internalControl.companyId", "brandId"])

  .index("by_company_and_category", ["internalControl.companyId", "categories"])
  .index("by_categories", ["categories"])
  .index("by_supplier", ["supplierId"])
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_branch_and_status", ["internalControl.branchId", "status"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ]);
